// NewUserForm.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NewUserForm = (prop) => {
  const InitState = {
    username: null,
    password: null,
    userRights: "E",
    activeStatus: "Yes",
    user: prop.username,
  };
  const [formData, setFormData] = useState(InitState);
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  useEffect(() => {
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") {
      setFormData({
        ...formData,
        [name]: value
          .replace(/[^a-zA-Z\s]/g, "")
          .trim()
          .toUpperCase(),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value.replace(/\s/g, ""),
      });
    }
  };
  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(formData);
    try {
      await axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/user/AddUser`, formData, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
          formData([]);
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    //console.log(formData);
    setFormData(InitState);
  };
  return (
    <div className="FormContainer">
      <ToastContainer />
      <h2 className="UserManagementFormHeadLabel">Activate New User</h2>
      <form className="UserManagementForm" onSubmit={handleSubmit}>
        <label className="UserManagementPageFormLables">Username </label>
        <input
          placeholder="Username"
          className="UserManagementPageFormInputs"
          onChange={handleChange}
          value={formData.username}
          required
          type="text"
          id="username"
          name="username"
        />
        <br />
        <label className="UserManagementPageFormLables">Password </label>
        <input
          placeholder="Password"
          className="UserManagementPageFormInputs"
          onChange={handleChange}
          value={formData.password}
          required
          type="password"
          id="password"
          name="password"
        />
        <br />
        <label className="UserManagementPageFormLables">User Rights</label>
        <select
          className="UserManagementPageFormInputs"
          onChange={handleChange}
          value={formData.userRights}
          required
          id="userRights"
          name="userRights"
        >
          <option value="E">Executive User</option>
          <option value="A">Admin User</option>
        </select>
        <br />
        <label className="UserManagementPageFormLables">Active Status</label>
        <select
          className="UserManagementPageFormInputs"
          onChange={handleChange}
          value={formData.activeStatus}
          required
          id="status"
          name="activeStatus"
        >
          <option value="YES">Active</option>
          <option value="NO">Inactive</option>
        </select>
        <br />
        <button
          className="UserManagementPageFormSumbit"
          title="Submit"
          type="submit"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default NewUserForm;
